'use client';

import type { TenantInfo } from '@repo/tenancy/types';
import { createContext, useContext } from 'react';

const TenantContext = createContext<{
  tenantConfig: TenantInfo['configuration'];
  tenantMachineName: TenantInfo['machineName'];
} | null>(null);

export const TenantProvider = ({
  children,
  tenantConfig,
  tenantMachineName,
}: {
  children: React.ReactNode;
  tenantConfig: TenantInfo['configuration'];
  tenantMachineName: TenantInfo['machineName'];
}) => {
  return <TenantContext.Provider value={{ tenantConfig, tenantMachineName }}>{children}</TenantContext.Provider>;
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};
